export default {"src":"/_next/static/media/parallel_handcuffs_40.d7508b1f.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};